"use client"
import { useState } from "react";
import { useRouter } from "next/navigation";
import { Info } from "lucide-react";
import PriceComponent from "@/components/ui/Price";
import { usePresaleCartStock } from "@/hooks/usePresaleCart";
import { useWebSiteContext } from "@core/helpers/client/contexts/WebSiteContext";
import { useAuthContext } from "@core/helpers/client/contexts/AuthContext";
import MediaComponent from "@/components/common/media-component";
import Button from "@/components/ui/button";
import ModalComponent from "@/components/ui/ModalComponent";
import Gateway from "../SingleProduct/_gateway";

export const SubmitButton = () => {
	const { web_route_names } = useWebSiteContext();
	const { out_stock_products_in_cart } = usePresaleCartStock();
	const { is_auth } = useAuthContext();
	const [isOpenModal, setIsOpenModal] = useState(false);
	const router = useRouter();

	return (
		is_auth ?
			(out_stock_products_in_cart?.length > 0 ?
				<>
					<Button
						onClick={() => setIsOpenModal(true)}
						text="تایید و ادامه"
						className="mx-auto w-full mt-3 lg:mt-0 lg:mb-5"
						color_type="primary"
					/>
					<ModalComponent
						isOpen={isOpenModal}
						onClose={() => setIsOpenModal(false)}
						title={out_stock_products_in_cart?.length > 1 ? "اتمام موجودی برخی محصولات" : "اتمام موجودی محصول"}
						size="md"
						partialHeight={500}
						footer={
							<Button
								text='تایید و ادامه '
								color_type="primary"
								variant="containd"
								className="w-full"
								onClick={(e) => {
									e?.preventDefault();
									router.push(web_route_names?.["checkout-page"]);
									setIsOpenModal(false);
								}}
							/>
						}
					>
						<p className="text-sm text-jmt-neutral-800">
							به دلیل اتمام موجودی {out_stock_products_in_cart?.length > 1 ? "محصولات" : "محصول"} زیر از سبد خرید حذف می شود.
						</p>
						<div className="mt-3">
							{out_stock_products_in_cart?.map((product) => (
								<div
									key={product?.product?.title}
									className={`flex items-center gap-2 py-2
										${out_stock_products_in_cart?.length > 1 ? 'not-last:border-b border-jmt-neutral-200 ' : ''}`}>

									<div className="aspect-square w-14">
										<MediaComponent
											src={product?.product?.mix_variant?.[0]?.media?.url || product?.product?.media?.url || product?.bundle?.extra_fields?.media?.url}
											alt="cart-item-img"
											width={50}
											height={50}
											style={{ width: "100%", height: "100%", objectFit: 'contain' }}
										/>
									</div>
									<p className="text-xs text-jmt-neutral-500 line-clamp-2">
										{product?.product?.title || product?.bundle?.title}
										<div className="inline-block">
											{product?.product?.mix_variant[0]?.title ? `(${product?.product?.mix_variant[0]?.title})` : ""}
										</div>
									</p>
								</div>
							))}
						</div>
					</ModalComponent>
				</>
				:
				<Button
					href={web_route_names?.["checkout-page"]}
					text="تایید و ادامه"
					color_type="primary"
					className="w-full mt-3 lg:mb-5 lg:mt-0"
				/>
			) :
			<>
				<Button
					href={`${web_route_names?.["auth"]}?redirect-to=${web_route_names?.["checkout-page"]}`}
					text="تایید و ادامه"
					className="w-full mt-3 lg:mb-5 lg:mt-0"
					color_type="primary"
				/>
			</>
	)
}
const Index = ({ cart }) => {
	const { check_if_all_items_exist } = usePresaleCartStock();

	return (
		cart?.products?.length > 0 &&
		<aside className="w-full lg:w-[400px] h-fit lg:sticky lg:top-[calc(var(--header-height)+16px)] pt-4 lg:p-0">
			<div className="lg:border border-jmt-neutral-200 lg:bg-jmt-neutral-50 lg:rounded-md lg:p-6 [&>.button-component]:hidden
			[&>.button-component]:lg:flex">

				{(check_if_all_items_exist &&
					<>

						<div className="flex items-center justify-between mb-4 w-full px-4 md:px-10 lg:px-0">

							<div className="flex items-center gap-1">
								<p className="text-sm font-bold text-jmt-neutral-800">قیمت محصولات</p>
								<p className="text-xs text-jmt-neutral-500">
									( {cart?.products?.reduce((acc, curr) => acc + curr?.count, 0)}
								</p>
								<span className="text-xs text-jmt-neutral-500">محصول )</span>
							</div>

							{cart?.total_prices?.sum_product_price_without_offer > 0 ?
								<PriceComponent price={cart?.total_prices?.sum_product_price_without_offer}
									className="text-sm lg:text-base font-bold text-jmt-neutral-800"
								/>
								: "رایگان"}
						</div>

						{cart?.total_prices?.sum_product_price_without_offer - cart?.total_prices?.sum_product_price > 0 &&
							<div className="flex items-center justify-between mb-4 w-full px-4 md:px-10 lg:px-0">
								<p className="text-sm font-bold text-jmt-green-600"> تخفیف محصولات  </p>
								<PriceComponent
									price={cart?.total_prices?.sum_product_price_without_offer - cart?.total_prices?.sum_product_price}
									className="text-sm lg:text-base font-bold text-jmt-green-600" />
							</div>}

						<div className="w-full px-4 md:px-10 lg:px-0">
							<div className="flex items-center justify-between font-bold lg:text-lg text-jmt-main mb-4 pt-2 border-t border-jmt-neutral-200">
								<span> جمع کل </span>
								<PriceComponent
									price={cart?.total_prices?.sum_product_price}
									/>
							</div>
						</div>

						<div className="block lg:hidden w-full h-0.5 bg-jmt-neutral-200 my-4" />

						<SubmitButton />

						<div className="flex flex-col gap-2 mb-2 w-full px-4 md:px-10 lg:px-0">
							<p className="font-bold text-sm text-jmt-main">مرحله بعد: آدرس و انتخاب شیوه ارسال</p>

							<div className="flex items-start gap-2">
								<Info size={18} className="shrink-0 text-jmt-neutral-500" />
								<span className="text-xs text-jmt-neutral-500">
									در صورتی که کالایی در سبد خرید، ناموجود شده است، با ادامه دادن به خرید، کالا به صورت خودکار از سبد خرید شما حذف می‌شود.
								</span>
							</div>
						</div>

						{/* installment */}
						<div className="w-full px-4 md:px-10 lg:px-0">
							<Gateway page_type={'cart'} />
						</div>

					</>
				)}
			</div>

		</aside >
	);
};

export default Index;
